export function getSharableVideoLinkQueryString(controller, audioPaths) {
  let searchParams = new URLSearchParams();
  let shareableVideoLink = getSharableVideoLink(controller, audioPaths);

  searchParams.append('track', shareableVideoLink.track);
  searchParams.append('soundfield', shareableVideoLink.soundField);
  searchParams.append('left', shareableVideoLink.left);
  searchParams.append('right', shareableVideoLink.right);
  searchParams.append('subtitle', shareableVideoLink.subtitle);

  if (shareableVideoLink.sidecarAudioPaths !== undefined) {
    for (const sidecarAudioPath of shareableVideoLink.sidecarAudioPaths) {
      searchParams.append('sidecarAudioPaths', sidecarAudioPath);
    }
  }

  return searchParams.toString();
}

function getSharableVideoLink(controller, audioPaths) {
  return {
    track:             controller.currentAudioTrack?.track,
    soundField:        controller.currentAudioTrack?.currentSoundfield,
    left:              controller.currentAudioTrack?.left,
    right:             controller.currentAudioTrack?.right,
    subtitle:          getSubtitleOption(controller),
    sidecarAudioPaths: audioPaths
  };
}

function getSubtitleOption(controller) {
  const hlsOption = controller.hlsSubtitles.find(o => o === controller.currentSubtitles);
  if (hlsOption) {
    return hlsOption;
  }

  else if (controller.currentSubtitles === 'Off') {
    return 'Off';
  }

  else {
    const sidecar = controller.sidecarSubtitles.find(s => s.id === controller.currentSubtitles);
    return sidecar ? sidecar.path : undefined;
  }
}